var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#info-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24M10.5 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-.375 3h2.25c.623 0 1.125.502 1.125 1.125v4.125h.375c.623 0 1.125.502 1.125 1.125S14.498 18 13.875 18h-3.75A1.12 1.12 0 0 1 9 16.875c0-.623.502-1.125 1.125-1.125h1.125v-3h-1.125A1.12 1.12 0 0 1 9 11.625c0-.623.502-1.125 1.125-1.125"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgInfoIcon;